import { tooltip } from './keymaps.ts';
import { isApple } from './keymaps.ts';
import { type Shortcuts, SHORTCUTS } from './shortcuts.ts';

export { SHORTCUTS, tooltip, isApple };
export type { Shortcuts };
